import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { translate } from '../../../base/i18n/functions';
import Icon from '../../../base/icons/components/Icon';
import { IconCheck } from '../../../base/icons/svg';
const useStyles = makeStyles()(theme => {
    return {
        itemContainer: {
            display: 'flex',
            // Button reset: the item used to be a click-only div, which made
            // every caption language unreachable by keyboard.
            background: 'none',
            border: 0,
            color: theme.palette.text02,
            alignItems: 'center',
            font: 'inherit',
            fontSize: '14px',
            cursor: 'pointer',
            padding: '5px 0',
            textAlign: 'left',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.ui04
            },
            '&:focus-visible': {
                outline: `2px solid ${theme.palette.ui05}`
            }
        },
        iconWrapper: {
            margin: '4px 10px',
            width: '22px',
            height: '22px'
        },
        activeItemContainer: {
            fontWeight: 700
        }
    };
});
/**
 * Component that renders the language list item.
 *
 * @returns {React$Element<any>}
 */
const LanguageListItem = ({ t, lang, selected, onLanguageSelected }) => {
    const { classes: styles } = useStyles();
    const onLanguageSelectedWrapper = useCallback(() => onLanguageSelected(lang), [lang]);
    return (React.createElement("button", { "aria-pressed": Boolean(selected), className: `${styles.itemContainer} ${selected ? styles.activeItemContainer : ''}`, onClick: onLanguageSelectedWrapper },
        React.createElement("span", { className: styles.iconWrapper }, selected
            && React.createElement(Icon, { src: IconCheck })),
        t(lang)));
};
export default translate(LanguageListItem);
